import runWalkme from './walkme.run';
import * as gzWalkMe from './walkme.service';

let moduleWalkme = angular.module('gazelle.components.walkme', [
  'rhino.components.tutorial',
  'rhino.components.user',
  'rhino.core',
])
  .service(gzWalkMe.name, gzWalkMe.default)
  .run(initGlobalsForWalkme);

function initGlobalsForWalkme($window, rnAUTH_EVENTS, $rootScope) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  $rootScope.$on(rnAUTH_EVENTS.authenticated, (event, data) => {
    _.set($window, 'printos.walkme.userId', data.entity.id);
    _.set($window, 'printos.walkme.userCreatedTime', data.entity.createdTime);
  });
}

// Don't include this while testing because of problems with extra $http calls
/* global __TEST__ */
if(!__TEST__) {
  moduleWalkme
    .run(runWalkme);
}

export default moduleWalkme.name;
